import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12m10-1a.75.75 0 0 0 0 1.5v3.75c0 .414.336.75.75.75h.75a.75.75 0 0 0 0-1.5v-3.75A.75.75 0 0 0 12 11zM12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      clipRule="evenodd"
    />
  </>
);

const InfoFilled = Icon('info-filled', svgContents);

export default InfoFilled;
